<template>
  <div class="share-container">
    <div class="header">
      <img src="./img/logo.png" alt="迷你logo" class="logo">
      <img src="./img/minier.png" alt="迷你人物" class="minier">
      <div class="btn" @click="openApp()">
        <img src="./img/gamebtn.png" alt="">
      </div>
    </div>
    <div class="content">
      <div class="title">为你推荐</div>
      <div class="mini-map" v-for="item in maps" :key="item.mapId" :style="`background-image: url(${item.mapCover})`" @click="openApp(item.mapId)">
        <span class="type" v-if="item.type">{{item.type}}</span>
        <div class="footer">
          <div class="tit">{{item.mapName}}</div>
          <div class="desc">
            <span class="author">{{`${item.uinName}(${item.uin})`}}</span>
            <div class="down-score">
              <span class="download">
                <img src="./img/download.png" alt="" class="icon">
                <span>{{item.downloadCount}}</span>
              </span>
              <span class="score">
                <img src="./img/score.png" alt="" class="icon">
                <span>{{item.score}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'
import Service from '&/services'
import deviceState from '@/services/device'
import WxService from '@/services/wx'
import ImageService from '@/services/image'

export default defineComponent({
  setup() {
    const state = reactive({
      maps: []
    })

    const getUnitCount = (num) => {
      if (!num) return 0
      if (num < 1000) return num
      // eslint-disable-next-line radix
      const w = parseInt(num / 10000, 0)
      const g = num % 10000
      const glabel = g < 1000 ? `0.0${g}` : `0.${g}`
      const f = parseFloat(parseFloat(glabel).toFixed(1))
      return w + f + '万'
    }
    const typeLableMap = {
      2: '冒险',
      3: '创造',
      4: '对战',
      5: '电路',
      6: '解密',
      7: '酷跑',
      8: '其他',
      9: '录像',
      10: '家园'
    }
    const initData = async () => {
      const resp = await Service.getMapDatas()
      state.maps = resp.map(item => ({ ...item,
        mapCover: item.mapCover ? item.mapCover.replace('http', 'https') : '',
        downloadCount: getUnitCount(item.downloadCount),
        type: typeLableMap[item.label] }))
      state.maps.forEach(async item => {
        item.mapCover = await Service.getMapidToCover(item.mapId)
      })
    }
    const initWx = () => {
      WxService.initWxShare({
        title: '快来一起开黑吧！', // 分享标题
        desc: '超好玩的沙盒游戏尽在《迷你世界》，一起玩呀！', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://image.mini1.cn/d/20210812/7a97786f9445aa232db1c6a6ec0d4cd4.png', // 分享图标
        success() {
          console.error('成功')
        }
      })
    }

    // 获取url地址参数
    const url_zb_wid = Utils.getQueryVariable('zb_wid') || 0 // 默认地址id
    const url_type = Utils.getQueryVariable('type') || 'externalrecommend' // 打开app类型
    const url_channel = Utils.getQueryVariable('channel') || '' // 打开app类型

    // 预留参数
    const reserveParams = {};
    ['v4', 'v5', 'v6', 'v7', 'v8', 'v9', 'v10'].forEach(key => {
      const temp_url_param = Utils.getQueryVariable(key)
      if (temp_url_param) {
        reserveParams[key] = temp_url_param
      }
    })

    const reportOptions = { v1: DeviceService.isMobile ? (DeviceService.isIos ? 'IOS' : 'Android') : '其他', v3: url_channel, ...reserveParams }
    const openApp = (zb_wid = '') => {
      let type = 'open_maproom_desc'
      if (!zb_wid) {
        Report.increase(10005).click('OpenApp', reportOptions) // app按钮打开
        zb_wid = url_zb_wid
        type = url_type
      } else {
        Report.increase(10005).click('MapCard', { ...reportOptions, v2: zb_wid }) // 点击地图打开
      }
      const param = {
        type,
        zb_wid
      }
      param.autoDownLoad = 1
      // 包含页面弹窗打开和关闭
      if (window.MiniApp) {
        window.MiniApp.open({
          param,
          appAlertCallback: () => Report.increase(10005).view('ClosePopup', reportOptions),
          appAlertFn: () => Report.increase(10005).view('Popup', reportOptions)
        })
      }
    }
    const init = () => {
      Report.increase(10005).view('FrontPage', reportOptions)
      initData()
      if (deviceState.isWechat) initWx()
    }

    init()
    return { ...toRefs(state), openApp }
  }
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
